function ViewableUrl({ row }: { row: any }) {
  const label = !!row.original.fedexLabel ? row.original.fedexLabel : {
    viewableUrl: row.original.viewableUrl,
    labelTitle: row.original.labelTitle
  }
  return (
    <td
      className={`${label?.viewableUrl && "text-[#084E8B] hover:underline text-sm"
        } py-1 block w-max rounded-full capitalize text-center `}
    >
      {label?.viewableUrl ? (
        <a href={label?.viewableUrl} target="_blank" onClick={(e) => e.stopPropagation()}>
          {!!label?.labelTitle ? label.labelTitle : "N/A"}
        </a>
      ) : (
        "N/A"
      )}
    </td>
  );
}

export default ViewableUrl;
